{
  "nav": {
    "classes": "Lớp học"
  },
  "classes": {
    "title": "Lớp học",
    "subtitle": "Lớp và khung giờ cố định. Buổi học thật nằm ở Bàn làm việc.",
    "tabs": {
      "list": "Danh sách",
      "grid": "Lịch cố định hàng tuần"
    },
    "newClass": "Tạo lớp",
    "empty": {
      "title": "Chưa có lớp nào.",
      "body": "Tạo lớp để xếp học viên, phần mềm tự sinh buổi học và điểm danh."
    },
    "filters": {
      "allTeachers": "Tất cả GV",
      "allSubjects": "Tất cả môn",
      "showEndedChip": "Đang hiện cả Đã kết thúc",
      "showArchivedChip": "Đang hiện cả Đã lưu trữ"
    },
    "pageMenu": {
      "showEnded": "Đã kết thúc",
      "showArchived": "Đã lưu trữ",
      "classModeSettings": "Cách tổ chức lớp…"
    },
    "list": {
      "columnClass": "Lớp",
      "columnSubject": "Môn",
      "columnSchedule": "Lịch hàng tuần",
      "columnTeacher": "Giáo viên",
      "columnCapacity": "Sĩ số",
      "columnStartsOn": "Bắt đầu",
      "full": "Đủ {{count}}",
      "statusUpcoming": "Sắp khai giảng",
      "statusEnded": "Đã kết thúc · {{from}} → {{to}}",
      "loadError": "Không tải được danh sách lớp.",
      "loading": "Đang tải...",
      "filterEmptyTitle": "Không có lớp nào khớp bộ lọc"
    },
    "toast": {
      "created": "Đã tạo lớp",
      "updated": "Đã cập nhật lớp",
      "archived": "Đã lưu trữ lớp",
      "archiveError": "Không thể lưu trữ lớp",
      "unarchived": "Đã khôi phục lớp",
      "unarchiveError": "Không thể khôi phục lớp",
      "memberSlotsUpdated": "Đã cập nhật khung giờ",
      "memberSlotsError": "Không thể cập nhật khung giờ",
      "memberRemoved": "Đã bỏ khỏi lớp",
      "memberRemoveError": "Không thể bỏ khỏi lớp"
    }
  },
  "classDetail": {
    "header": {
      "addMembers": "Thêm học viên",
      "editClass": "Sửa lớp",
      "endClass": "Kết thúc lớp",
      "archive": "Lưu trữ",
      "unarchive": "Khôi phục",
      "attendanceMonth": "Điểm danh tháng",
      "window": "Bắt đầu {{start}} → {{end}}",
      "windowOpen": "Bắt đầu {{start}}, chạy liên tục",
      "roster": "Sĩ số {{count}}",
      "ended": "Đã kết thúc {{date}}",
      "upcoming": "Sắp khai giảng {{date}}"
    },
    "roster": {
      "title": "Học viên",
      "emptyTitle": "Chưa có học viên.",
      "emptyBody": "Thêm từ danh sách, tạo mới, hoặc nhập từ file Excel của lớp.",
      "columnStudent": "Học viên",
      "columnSlots": "Khung giờ",
      "columnStart": "Bắt đầu",
      "columnFee": "Học phí",
      "termUnit": "buổi",
      "partial": "{{joined}}/{{total}} khung giờ",
      "editSlots": "Sửa khung giờ",
      "editSlotsAria": "Sửa khung giờ của {{name}}",
      "openStudent": "Mở trang học viên",
      "removeFromClass": "Bỏ khỏi lớp",
      "rowMenuAria": "Thao tác cho {{name}}",
      "pausedNote": "xếp lớp được bảo lưu"
    },
    "slots": {
      "title": "Khung giờ",
      "duration": "{{minutes}} phút",
      "editAria": "Sửa khung giờ này",
      "next": "Buổi gần nhất: {{day}} {{date}}",
      "nextToday": "Hôm nay {{time}}, chưa điểm danh"
    },
    "review": {
      "title": "Nhận xét tháng",
      "monthTitle": "Tháng {{month}}",
      "progress": "{{done}}/{{total}} đã nhận xét",
      "hint": "Viết sau buổi cuối tháng, AI soạn nháp từ các dòng đã ghi.",
      "link": "Mở Nhận xét tháng · {{subject}}"
    },
    "popover": {
      "title": "Khung giờ của {{name}}",
      "fromDate": "từ {{date}}",
      "newTag": "Mới",
      "fromLabel": "Từ",
      "consequence": "Bỏ tick một khung giờ: buổi tương lai của khung đó không còn em này, buổi đã điểm danh giữ nguyên.",
      "cancel": "Huỷ",
      "save": "Lưu"
    },
    "endDialog": {
      "title": "Kết thúc lớp?",
      "consequence": "Từ ngày này lớp ngừng sinh buổi. Buổi tương lai chưa điểm danh sau ngày đó sẽ bị xoá, lịch sử giữ nguyên.",
      "dateLabel": "Ngày kết thúc",
      "cancel": "Huỷ",
      "confirm": "Kết thúc lớp",
      "error": "Không thể kết thúc lớp"
    },
    "archiveConfirm": {
      "title": "Lưu trữ lớp này?",
      "body": "Lưu trữ lớp và mọi khung giờ của lớp. Các buổi tương lai chưa điểm danh sẽ bị xoá, lịch sử vẫn giữ.",
      "action": "Lưu trữ"
    },
    "removeConfirm": {
      "title": "Bỏ khỏi lớp?",
      "body": "Bỏ {{name}} khỏi lớp: các buổi tương lai của mọi khung giờ trong lớp không còn học viên này, buổi đã điểm danh giữ nguyên.",
      "action": "Bỏ khỏi lớp"
    }
  },
  "classForm": {
    "createTitle": "Tạo lớp",
    "editTitle": "Sửa lớp",
    "createDescriptionCohort": "Lớp gom các khung giờ hàng tuần. Học viên và học phí thêm sau khi tạo.",
    "editDescription": "Thay đổi chỉ áp dụng cho các buổi trong tương lai, buổi đã diễn ra giữ nguyên. Lớp gắn cố định với môn học; cần môn khác, hãy tạo lớp mới.",
    "a11yTitle": "Biểu mẫu lớp học",
    "genericError": "Không thể lưu lớp",
    "sectionInfo": "Thông tin lớp",
    "name": "Tên lớp",
    "nameOptional": "Tên lớp (tuỳ chọn)",
    "namePlaceholderCohort": "VD: Toán 8 tối T3-T5",
    "namePlaceholderDerived": "Để trống sẽ hiện {{preview}}",
    "subject": "Môn học",
    "teacher": "Giáo viên",
    "teacherResponsible": "GV chịu trách nhiệm",
    "branch": "Chi nhánh",
    "branchNone": "Không thuộc chi nhánh",
    "room": "Phòng / ghi chú (tuỳ chọn)",
    "roomUnchangedHint": "Để trống nếu không đổi phòng hiện tại.",
    "capacity": "Sĩ số tối đa",
    "capacityHint": "Để trống là không giới hạn, 1 là kèm 1-1.",
    "sectionSchedule": "Lịch học hàng tuần",
    "startTime": "Giờ bắt đầu",
    "duration": "Thời lượng (phút)",
    "perDayToggle": "Giờ hoặc giáo viên khác nhau giữa các ngày",
    "perDayDay": "Thứ",
    "perDayHour": "Giờ",
    "perDayMinute": "Phút",
    "perDayTeacher": "Giáo viên",
    "teacherLockedTooltip": "Khung giờ gắn cố định với giáo viên. Cần giáo viên khác, bỏ khung giờ này và thêm khung giờ mới.",
    "removeDayConsequence": "Bỏ {{day}} {{time}}: các buổi tương lai chưa điểm danh sẽ bị xoá, lịch sử vẫn giữ. {{count}} học viên đang ở khung giờ này.",
    "undo": "Hoàn lại",
    "startsOn": "Ngày bắt đầu",
    "startsOnHint": "Lớp đã dạy từ trước? Chọn đúng ngày buổi đầu, phần mềm tạo sẵn các buổi đã qua để điểm danh bù.",
    "endsOn": "Ngày kết thúc",
    "endsOnOptional": "(tuỳ chọn)",
    "endsOnHintCreate": "Để trống nếu lớp chạy liên tục. Đến ngày này lớp ngừng sinh buổi, lịch sử giữ nguyên.",
    "endsOnHintEdit": "Sau ngày này lớp đọc là \"Đã kết thúc\".",
    "addEndDate": "Thêm ngày kết thúc",
    "sectionPricing": "Học phí mặc định cho học viên mới",
    "pricingSessionMonthlyLabel": "Theo buổi",
    "pricingSessionMonthlyDesc": "Đếm buổi có mặt, bù trừ kỳ chốt sổ sau",
    "pricingSessionTermLabel": "Theo khoá",
    "pricingSessionTermDesc": "Đóng trước N buổi",
    "pricingMonthlyFlatLabel": "Tháng cố định",
    "pricingMonthlyFlatDesc": "Một khoản mỗi tháng, thu trước đầu tháng",
    "ratePerSession": "Học phí mỗi buổi (đ)",
    "monthlyRate": "Học phí mỗi tháng (đ)",
    "termSize": "Số buổi trong khoá",
    "chargeAbsent": "Nghỉ không phép vẫn tính học phí",
    "pricingHint": "Chỉ điền sẵn khi thêm học viên vào lớp. Học phí thật nằm trên đăng ký của từng em và sửa riêng được.",
    "sectionColor": "Màu trên lịch",
    "colorAuto": "Tự động",
    "colorTooltip": "Tự động: lớp có từ hai khung giờ trở lên được tô màu để nhận ra nhau trên lịch.",
    "colorSwatchLabel": "Màu {{n}}",
    "colorChosen": "Đã chọn màu",
    "rateFromSubject": "{{rate}} (giá môn học)",
    "pricingColorSummaryLabel": "Học phí mặc định và màu trên lịch",
    "cancel": "Huỷ",
    "submitCreate": "Tạo lớp",
    "submitEdit": "Lưu",
    "discardTitle": "Bỏ thay đổi?",
    "discardBody": "Các thay đổi chưa lưu sẽ mất.",
    "discardConfirm": "Bỏ thay đổi",
    "discardCancel": "Tiếp tục sửa",
    "loading": "Đang tải..."
  },
  "addMembers": {
    "title": "Thêm học viên vào {{class}}",
    "confirmTitle": "Xác nhận thêm vào {{class}}",
    "defaultFeeNote": "học phí mặc định {{rate}}",
    "loading": "Đang tải...",
    "cancel": "Huỷ",
    "continue": "Tiếp tục",
    "back": "Quay lại",
    "unit": {
      "month": "tháng",
      "session": "buổi"
    },
    "tabs": {
      "create": "Tạo mới",
      "pick": "Chọn từ danh sách",
      "import": "Nhập từ Excel"
    },
    "create": {
      "name": "Họ và tên",
      "namePlaceholder": "VD: Nguyễn Văn An",
      "nickname": "Tên thường gọi",
      "nicknamePlaceholder": "VD: Bơ",
      "dob": "Ngày sinh",
      "payer": "Người trả phí",
      "payerPlaceholder": "Tên người trả phí",
      "phone": "SĐT / Zalo",
      "payerSearchPlaceholder": "Tìm người trả phí...",
      "payerEmpty": "Không tìm thấy",
      "newPayerLink": "Nhập người trả phí mới",
      "existingPayerLink": "Chọn người trả phí có sẵn",
      "selfPayLink": "Học viên tự trả",
      "selfPayNote": "Học viên tự trả (người lớn)",
      "dupFound": "Đã có: {{name}}, khách hàng {{payer}}",
      "weakDupFound": "Có thể trùng với {{name}}, khách hàng {{payer}}",
      "dupStudying": "đang học {{subjects}}",
      "useExisting": "Dùng học viên đã có",
      "createNewInstead": "Tạo mới",
      "useExistingHint": "Dùng học viên đã có: chỉ tạo đăng ký {{subject}} và xếp vào lớp, hồ sơ không đổi.",
      "removeRow": "Bỏ dòng này",
      "addRow": "Thêm dòng",
      "footerCount": "{{newCount}} học viên mới · {{existingCount}} dùng hồ sơ có sẵn"
    },
    "pick": {
      "searchPlaceholder": "Không phân biệt dấu · tìm theo tên",
      "resultCount": "{{count}} kết quả",
      "emptyPrompt": "Gõ tên để tìm học viên",
      "noResults": "Không tìm thấy học viên nào",
      "alreadyInClass": "Đã trong lớp {{name}}",
      "hasEnrollment": "Đã có đăng ký {{subject}} · {{rate}}/{{unit}}",
      "pausedEnrollment": "Đang tạm dừng đăng ký {{subject}}",
      "noEnrollment": "Chưa có đăng ký {{subject}}",
      "selectedCount": "Đã chọn {{count}} học viên"
    },
    "confirm": {
      "subtitle": "{{count}} học viên · học phí và khung giờ sửa riêng từng em được",
      "startDate": "Ngày bắt đầu",
      "pricingLabel": "Hình thức học cho cả nhóm",
      "pricing": {
        "SESSION_MONTHLY": "Theo buổi",
        "SESSION_TERM": "Theo khoá",
        "MONTHLY_FLAT": "Tháng cố định"
      },
      "termSize": "Số buổi trong khoá",
      "termSizeRequired": "Nhập số buổi trong khoá để tiếp tục.",
      "colStudent": "Học viên",
      "colFeeMonth": "Học phí / tháng",
      "colFeeSession": "Học phí / buổi",
      "colSlots": "Khung giờ",
      "colNote": "Ghi chú",
      "note": {
        "paused": "Đang tạm dừng, tiếp tục học trước rồi xếp lớp",
        "pricingLocked": "Đã có đăng ký {{subject}} theo hình thức khác, giữ giá {{rate}}/{{unit}}",
        "keepRate": "Đã có đăng ký {{subject}}, giữ giá {{rate}}/{{unit}}.",
        "existingPartial": "Dùng hồ sơ có sẵn. Chỉ học một số khung giờ; theo buổi nên chỉ trả buổi có học.",
        "existingProfile": "Dùng hồ sơ có sẵn. Đăng ký {{subject}} mới theo mặc định lớp.",
        "newDefault": "Đăng ký {{subject}} mới theo mặc định lớp."
      },
      "duplicateError": "Có học viên bị trùng trong danh sách, kiểm tra lại trước khi thêm.",
      "excludedNote": "{{count}} học viên đang tạm dừng đăng ký, không nằm trong lượt thêm này.",
      "repriceHint": "Học phí đổi ở đây theo luật Sửa học phí: áp dụng cho mọi thứ chưa xuất hoá đơn.",
      "termFooterNote": "Bắt đầu khoá và hoá đơn thu trước vẫn làm trên trang từng em.",
      "editRate": "Sửa học phí",
      "submitting": "Đang thêm...",
      "submit": "Thêm {{count}} học viên",
      "successToast": "Đã thêm {{count}} học viên vào {{class}}",
      "retryToast": "Hệ thống đang bận, vui lòng thử lại.",
      "genericError": "Không thể thêm học viên"
    }
  },
  "grid": {
    "note": "Đây là khung cố định hàng tuần, không phải buổi học. Buổi thật, điểm danh xem ở",
    "jumpToDay": "Nhảy tới ngày"
  },
  "timetable": {
    "allTeachers": "Tất cả GV",
    "empty": "Chưa có khung giờ nào",
    "emptyArchived": "Chưa có khung giờ nào được lưu trữ",
    "emptyArchivedHint": "Khung giờ đã lưu trữ sẽ nằm ở đây, khôi phục lại được bất cứ lúc nào.",
    "emptyHint": "Tạo khung giờ cố định hàng tuần để xếp học viên và tự động sinh buổi học, điểm danh.",
    "today": "Hôm nay",
    "newSlot": "Tạo lớp"
  },
  "slot": {
    "create": "Tạo khung giờ",
    "edit": "Sửa khung giờ",
    "teacher": "Giáo viên",
    "teacherOwner": "GV chịu trách nhiệm",
    "teacherOwnerHint": "Hiện trên thẻ lớp và bộ lọc thời khoá biểu. Không ảnh hưởng tiền công, các GV Chính đều tính như nhau.",
    "teacherList": "Giáo viên",
    "addTeacher": "Thêm giáo viên",
    "removeTeacher": "Bỏ {{name}} khỏi lớp",
    "roleChinh": "Chính",
    "roleTroGiang": "Trợ giảng",
    "moreTeachers": "+{{count}} GV",
    "subject": "Môn học",
    "branch": "Chi nhánh",
    "branchNone": "Không thuộc chi nhánh",
    "branchArchived": "{{name}} (đã lưu trữ)",
    "day": "Thứ",
    "startTime": "Giờ",
    "duration": "Thời lượng (phút)",
    "capacity": "Sĩ số tối đa",
    "capacityOfClass": "Sĩ số tối đa {{count}} là của cả lớp.",
    "capacityOfClassLink": "Sửa ở trang lớp",
    "name": "Tên lớp (tùy chọn)",
    "members": "Học viên",
    "archive": "Lưu trữ",
    "archiveConfirm": {
      "title": "Lưu trữ khung giờ này?",
      "body": "Các buổi tương lai chưa điểm danh sẽ bị xoá, lịch sử vẫn giữ.",
      "action": "Lưu trữ"
    },
    "restore": "Khôi phục",
    "restored": "Đã khôi phục khung giờ",
    "minutes": "phút",
    "officialMembers": "Học viên chính thức",
    "noMembers": "Chưa có học viên",
    "pausedSection": "Đã tạm ngưng",
    "pausedTag": "tạm ngưng",
    "showActive": "Đang hoạt động",
    "showArchived": "Đã lưu trữ",
    "cancel": "Huỷ",
    "submit": "Lưu",
    "editDescription": "Thay đổi chỉ áp dụng cho các buổi trong tương lai, buổi đã diễn ra giữ nguyên. Khung giờ gắn cố định với môn học và giáo viên. Cần môn hay giáo viên khác, hãy thêm khung giờ mới trong lớp.",
    "addMember": "Thêm học viên",
    "addMemberPlaceholder": "Chọn học viên...",
    "removeAria": "Xoá {{name}} khỏi lớp",
    "removeConfirm": {
      "title": "Xoá khỏi lớp?",
      "titleTemplate": "Xoá khỏi mẫu?",
      "bodyReality": "Xoá {{name}} khỏi khung giờ học chính thức, các buổi tương lai của khung giờ này sẽ không còn học viên này. Buổi đã điểm danh không đổi.",
      "bodyTemplate": "Xoá {{name}} khỏi khung giờ này trong mẫu, xếp lớp thật không thay đổi gì.",
      "action": "Xoá khỏi lớp"
    }
  },
  "assign": {
    "title": "Xếp lớp",
    "recurringTitle": "Lớp {{subject}} đang mở",
    "recurringHint": "Học đều mỗi tuần theo khung giờ của lớp",
    "startDateLabel": "Ngày bắt đầu",
    "startDateHint": "Áp dụng cho lớp bạn xếp bên dưới. Chọn ngày đã qua để tính luôn buổi đã diễn ra (điểm danh được).",
    "joinFrom": "Xếp vào lớp · từ {{date}}",
    "overCapacity": "Vượt sĩ số, vẫn xếp được",
    "joined": "Đã xếp",
    "leave": "Bỏ khỏi lớp",
    "onlySomeSlots": "Chỉ một số khung giờ",
    "onlySomeSlotsNote": "Tính tiền theo buổi thật, nên chỉ học T2 thì chỉ trả T2.",
    "createClass": "Tạo lớp mới",
    "emptyClasses": "Chưa có lớp {{subject}} nào",
    "classPrefix": "Lớp {{name}}",
    "classPartial": "{{joined}}/{{total}} khung giờ",
    "membersMore": "+{{count}}",
    "notAssigned": "Chưa xếp lớp",
    "oneOffTitle": "Buổi lẻ (học bù / học thêm)",
    "oneOffHint": "Một buổi duy nhất, không lặp lại"
  },
  "days": {
    "1": "T2",
    "2": "T3",
    "3": "T4",
    "4": "T5",
    "5": "T6",
    "6": "T7",
    "7": "CN"
  },
  "moveMode": {
    "toggleOn": "Xếp lớp hàng loạt",
    "toggleOff": "Thoát xếp lớp",
    "hintStart": "Bắt đầu bằng cách tick chọn học viên trong một khung giờ, sau đó kéo nhóm sang khung giờ đích hoặc chọn ở thanh dưới. Chỉ chuyển được sang khung giờ cùng môn học.",
    "hintTarget": "Kéo nhóm sang khung giờ đích, hoặc chọn ở thanh dưới.",
    "pausedNotice": "{{count}} học viên tạm ngưng không hiển thị ở đây, chuyển qua trang học viên.",
    "sourceBadge": "Khung giờ nguồn",
    "targetBadge": "Khung giờ đích",
    "previewChipTitle": "Sẽ chuyển vào khung giờ này khi xác nhận",
    "otherSubject": "Khác môn học",
    "bar": {
      "count": "Chuyển {{count}} học viên",
      "pickTarget": "Chọn khung giờ đích",
      "confirm": "Xác nhận",
      "confirming": "Đang chuyển...",
      "cancel": "Huỷ",
      "ariaLabel": "Chuyển học viên sang khung giờ khác"
    },
    "picker": {
      "title": "Chọn khung giờ đích",
      "description": "Chỉ hiện khung giờ cùng môn học, đang hoạt động và khác khung giờ nguồn.",
      "empty": "Không có khung giờ nào phù hợp để chuyển đến."
    },
    "dragBadge": "{{count}} HV",
    "hintTargetMobile": "Chọn khung giờ đích ở thanh dưới."
  },
  "template": {
    "label": "Mẫu lịch học",
    "menuLabel": "Tuỳ chọn mẫu",
    "createItem": "+ Tạo mẫu…",
    "appliedNote": "Đã áp dụng {{date}}",
    "liveNote": "Mẫu lịch học này chỉ chứa thông tin xếp lớp: học viên nào sẽ vào khung giờ nào sau khi áp dụng. Việc thêm, sửa, lưu trữ lớp và khung giờ luôn có hiệu lực thật.",
    "apply": "Áp dụng…",
    "rename": "Đổi tên mẫu",
    "delete": "Xoá mẫu",
    "exit": "Thoát",
    "loadError": "Không tải được mẫu lịch học, đã quay về Thực tế",
    "backupPrefix": "Sao lưu",
    "inactiveChip": "Học viên đã nghỉ, sẽ bị bỏ qua khi áp dụng",
    "orphanPopover": {
      "aria": "Vì sao khung giờ này bị bỏ qua khi áp dụng?",
      "label": "Chú ý",
      "body": "Khung giờ này đã bị lưu trữ ở lịch cố định hiện hành, các học viên xếp ở đây sẽ bị bỏ qua khi áp dụng.",
      "restoreAction": "Khôi phục khung giờ",
      "restoreConfirm": {
        "title": "Khôi phục khung giờ này?",
        "body": "Khung giờ sẽ hoạt động trở lại trên lịch cố định hiện hành và bắt đầu sinh buổi học như cũ."
      }
    },
    "create": {
      "title": "Tạo mẫu lịch học",
      "nameLabel": "Tên mẫu",
      "namePlaceholder": "VD: Lịch hè / Lịch trong năm học",
      "modeLabel": "Bắt đầu từ",
      "empty": "Trống",
      "copy": "Sao chép xếp lớp hiện tại",
      "submit": "Tạo mẫu"
    },
    "renameDialog": {
      "title": "Đổi tên mẫu",
      "submit": "Lưu"
    },
    "deleteConfirm": {
      "title": "Xoá mẫu này?",
      "body": "Chỉ xoá bản nháp, việc xếp lớp thật không thay đổi gì.",
      "action": "Xoá mẫu"
    },
    "applyDialog": {
      "title": "Áp dụng mẫu lịch học",
      "loading": "Đang tính thay đổi…",
      "counts": "{{joins}} học viên vào · {{leaves}} học viên ra · {{unchanged}} giữ nguyên",
      "orphanWarning": "Khung giờ {{label}} đã lưu trữ, {{n}} học viên trong mẫu sẽ không được xếp",
      "backupNote": "Xếp lớp hiện tại sẽ được sao lưu thành một mẫu mới, muốn quay lại thì áp dụng mẫu đó.",
      "guidance": "Áp dụng có hiệu lực ngay. Nên bấm sau buổi học cuối của tháng, tốt nhất tối 31/8 hoặc sáng 1/9.",
      "blocked": "Tháng {{m}} chưa chốt sổ, chốt trước khi áp dụng để số liệu tháng cũ đứng yên.",
      "goClose": "Đi chốt sổ",
      "cancel": "Huỷ",
      "confirm": "Áp dụng",
      "applying": "Đang áp dụng…",
      "toast": "Đã áp dụng: {{joined}} học viên vào, {{left}} học viên ra",
      "toastWithBackup": "Đã áp dụng. Bản sao lưu: {{name}}",
      "noChanges": "Mẫu này đã trùng với thực tế, không có gì để thay đổi."
    }
  },
  "sessions": {
    "status": {
      "SCHEDULED": "Đã xếp",
      "COMPLETED": "Đã dạy",
      "CANCELLED": "Đã hủy"
    }
  },
  "oneOff": {
    "date": "Ngày",
    "time": "Giờ",
    "duration": "Thời lượng (phút)",
    "add": "Thêm buổi lẻ"
  },
  "session": {
    "detail": "Chi tiết buổi học",
    "teacher": "GV chịu trách nhiệm",
    "changeTeacher": "Đổi giáo viên",
    "moreTeachers": "+{{count}} GV",
    "subject": "Môn",
    "time": "Thời gian",
    "participants": "Học viên trong buổi",
    "addStudent": "Thêm học viên",
    "addSearchPlaceholder": "Tìm học viên...",
    "addEmpty": "Không tìm thấy học viên",
    "addHint": "Thêm vào riêng buổi này (học bù / học ké), không thêm vào lịch cố định hàng tuần.",
    "removeStudent": "Bỏ khỏi buổi",
    "move": "Chuyển suất",
    "reschedule": "Đổi giờ",
    "cancel": "Hủy buổi",
    "note": "Ghi chú",
    "noteFor": "Nhận xét riêng cho {{name}}",
    "back": "Quay lại",
    "teacherAdhocPopover": {
      "body": "Giáo viên này không thuộc lịch cố định của khung giờ, chỉ dạy buổi này.",
      "billing": "Buổi dạy vẫn tính tiền công như bình thường."
    }
  },
  "attendance": {
    "title": "Điểm danh",
    "present": "Có mặt",
    "absent": "Vắng",
    "excused": "Có phép",
    "discard": "Huỷ",
    "markAllPresent": "Tất cả có mặt",
    "save": "Lưu điểm danh",
    "saving": "Đang lưu...",
    "notYet": "Chưa tới giờ điểm danh",
    "upcoming": "Sắp diễn ra",
    "done": "Đã điểm danh",
    "note": "Lý do (nếu nghỉ phép)",
    "attended": "đã học",
    "sessions": "buổi",
    "adhoc": "Đột xuất",
    "adhocPopover": {
      "body": "Học viên được thêm riêng cho buổi này, không thuộc lịch cố định của lớp, tuần sau không lặp lại.",
      "billing": "Điểm danh vẫn tính như buổi thường; học viên đóng theo buổi sẽ được tính vào kỳ chốt sổ tới.",
      "aria": "Vì sao {{name}} là đột xuất?"
    },
    "removeTitle": "Gỡ học viên khỏi buổi này?",
    "removeDescription": "Chỉ gỡ khỏi buổi lẻ/học bù này, không ảnh hưởng lịch cố định.",
    "removeCancel": "Hủy",
    "removeConfirm": "Gỡ",
    "officialRemoveTitle": "Không gỡ được học viên chính thức",
    "officialRemoveDescription": "Học viên chính thức (từ lịch cố định) được quản lý ở phần Xếp lớp. Chỉ có thể gỡ học viên đột xuất (học bù / đổi suất). Nếu học viên nghỉ buổi này, hãy điểm danh Có phép.",
    "close": "Đóng",
    "quotaWarning": "Đã dùng hết {{limit}} buổi phép tháng này, buổi này nên tính là vắng?",
    "madeUpSuffix": "(đã bù {{count}})",
    "quotaChip": "Phép {{quota}}",
    "quotaChipAria": "Giải thích số buổi nghỉ phép của {{name}}",
    "modeBadge": {
      "SESSION_MONTHLY": "Buổi",
      "SESSION_TERM": "Khoá",
      "MONTHLY_FLAT": "Tháng",
      "termWithPosition": "Khoá {{termIndex}}/{{termSize}}",
      "aria": "Hình thức học của {{name}}: {{badge}}"
    },
    "modePopover": {
      "position": "Buổi hôm nay là buổi thứ {{termIndex}} trong khoá {{termSize}} buổi, còn {{remaining}} buổi.",
      "positionLast": "Buổi hôm nay là buổi thứ {{termIndex}} trong khoá {{termSize}} buổi, buổi cuối của khoá.",
      "positionOverrun": "Buổi hôm nay là buổi thứ {{termIndex}} trong khoá {{termSize}} buổi, đã dùng quá {{over}} buổi.",
      "noOpenTerm": "Khoá đã dùng hết, gia hạn ở trang học viên."
    },
    "quotaPopover": {
      "madeUpRule": "Nếu trong tháng học viên này đi học bù, số phép đã dùng sẽ được hoàn lại.",
      "withLimit": "Tháng này {{name}} nghỉ có phép {{used}} buổi trong hạn mức {{limit}}.",
      "withLimitMadeUp": "Tháng này {{name}} nghỉ có phép {{used}} buổi trong hạn mức {{limit}}. {{madeUp}} buổi đã học bù nên được hoàn phép.",
      "noLimit": "Tháng này {{name}} nghỉ có phép {{used}} buổi.",
      "noLimitMadeUp": "Tháng này {{name}} nghỉ có phép {{used}} buổi. {{madeUp}} buổi đã học bù nên được hoàn phép."
    },
    "chargeNote": {
      "chargedMonthly": "Buổi vắng này sẽ được tính học phí.",
      "chargedTerm": "Buổi vắng này sẽ tính vào số buổi của khóa.",
      "notCharged": "Buổi vắng này không tính học phí.",
      "flat": "Không ảnh hưởng học phí (trọn gói tháng)."
    },
    "locked": "Đã chốt sổ tháng {{month}}, mở lại tháng để sửa điểm danh.",
    "lockedNoMonth": "Đã chốt sổ, mở lại tháng để sửa điểm danh.",
    "progress": "{{marked}}/{{total}} đã điểm",
    "barAriaLabel": "Lưu điểm danh cho suất này"
  },
  "attendanceGrid": {
    "searchPlaceholder": "Tìm học viên...",
    "showAll": "Xem tất cả",
    "showExceptions": "Chỉ xem còn thiếu",
    "student": "Học viên",
    "excused": "Phép",
    "madeUp": "Bù",
    "absent": "Vắng",
    "pending": "Chưa",
    "empty": "Không có buổi nào trong tháng này",
    "allClear": "Đã điểm danh đầy đủ cho tháng {{month}} 🎉",
    "noMatch": "Không tìm thấy học viên phù hợp",
    "markCta": "Điểm danh còn thiếu",
    "markCellLabel": "Điểm danh buổi {{date}}",
    "openCta": "Mở buổi học",
    "openCellLabel": "Mở buổi {{date}}",
    "pendingCountLabel": "{{count}} buổi chưa điểm danh"
  },
  "monthGrid": {
    "title": "Điểm danh tháng",
    "subtitle": "Bảng ✓/✗ của cả lớp, bấm vào ô để mở buổi đó.",
    "pickMonth": "Chọn tháng xem điểm danh",
    "thisMonth": "Tháng này",
    "searchPlaceholder": "Tìm theo tên hoặc tên gọi ở nhà",
    "gridTitle": "Tháng {{month}}",
    "onlyStudent": "Chỉ xem: {{name}}",
    "onlyStudentClear": "Bỏ lọc học viên",
    "emptyMonth": "Tháng {{month}} không có buổi học nào.",
    "emptyFilteredTitle": "Không có học viên nào khớp bộ lọc",
    "emptyFilteredBody": "Thử bỏ bớt bộ lọc, hoặc chọn tháng khác.",
    "loadError": "Không tải được dữ liệu điểm danh."
  }
}
